import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import AppShell from "@/components/app/AppShell";
import FlagGuard from "@/components/app/FlagGuard";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Players from "@/pages/Players";
import PlayerDetail from "@/pages/PlayerDetail";
import Fixtures from "@/pages/Fixtures";
import MyTeam from "@/pages/MyTeam";
import Leagues from "@/pages/Leagues";
import LeagueDetail from "@/pages/LeagueDetail";
import LeagueDiff from "@/pages/LeagueDiff";
import Profile from "@/pages/Profile";
import AskFpl from "@/pages/AskFpl";
import Compare from "@/pages/Compare";
import RankGap from "@/pages/RankGap";
import Live from "@/pages/Live";

import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminUsers from "@/admin/AdminUsers";
import AdminFeatures from "@/admin/AdminFeatures";
import AdminSetPieces from "@/admin/AdminSetPieces";
import AdminLineups from "@/admin/AdminLineups";
import AdminAudit from "@/admin/AdminAudit";
import AdminHealth from "@/admin/AdminHealth";

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Consumer app */}
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<AppShell />}>
            <Route index element={<Home />} />
            <Route path="players" element={<Players />} />
            <Route path="players/:id" element={<PlayerDetail />} />
            <Route path="fixtures" element={<Fixtures />} />
            <Route path="my-team" element={<MyTeam />} />
            <Route path="leagues" element={<Leagues />} />
            <Route path="leagues/:id" element={<LeagueDetail />} />
            <Route path="leagues/:id/diff" element={<FlagGuard flag="rival_diff"><LeagueDiff /></FlagGuard>} />
            <Route path="profile" element={<Profile />} />
            <Route path="ask" element={<FlagGuard flag="ask_fpl"><AskFpl /></FlagGuard>} />
            <Route path="compare" element={<FlagGuard flag="player_compare"><Compare /></FlagGuard>} />
            <Route path="rank-gap" element={<FlagGuard flag="rank_gap"><RankGap /></FlagGuard>} />
            <Route path="live" element={<FlagGuard flag="live_rank_tracker"><Live /></FlagGuard>} />
          </Route>

          {/* Admin app — separate shell */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="features" element={<AdminFeatures />} />
            <Route path="set-pieces" element={<AdminSetPieces />} />
            <Route path="lineups" element={<AdminLineups />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="health" element={<AdminHealth />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#181B20",
            border: "1px solid #262A30",
            color: "#E4E8EE",
            fontFamily: "Inter, system-ui, sans-serif",
          },
        }}
      />
    </>
  );
}
